import type { SchemaConditions } from 'cpool-schemas';
import type { UseTranslationResponse } from 'react-i18next';

export const createResidualDebtInsuranceString = (
    conditionResidualDebtInsurance: SchemaConditions['residualDebtInsurance'],
    hasSecondApplicant: boolean,
    t: UseTranslationResponse<'de', undefined>['t'], // maybe we need to change this to a more generic type, but this allows to check the translation path
) => {
    const applicantResidualDebtInsurances: { applicant1: Array<string>; applicant2: Array<string> } = {
        applicant1: [],
        applicant2: [],
    };
    if (conditionResidualDebtInsurance?.applicant1?.death?.existing)
        applicantResidualDebtInsurances.applicant1.push(
            t('BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.HEADER_NOTIFICATIONS.DEATH'),
        );
    if (conditionResidualDebtInsurance?.applicant1?.workIncapacity?.existing)
        applicantResidualDebtInsurances.applicant1.push(
            t('BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.HEADER_NOTIFICATIONS.WORK_INCAPACITY'),
        );
    if (conditionResidualDebtInsurance?.applicant1?.unemployment?.existing)
        applicantResidualDebtInsurances.applicant1.push(
            t('BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.HEADER_NOTIFICATIONS.UNEMPLOYMENT'),
        );

    const firstApplicantString = `${
        applicantResidualDebtInsurances.applicant1.length > 0
            ? applicantResidualDebtInsurances.applicant1.join(', ')
            : '-'
    } (${t('BANK_CREDIT_REQUEST.HISTORY.SECTION_HEADER.FIRST_APPLICANT')})`;

    if (!hasSecondApplicant) return firstApplicantString;

    if (conditionResidualDebtInsurance?.applicant2?.death?.existing)
        applicantResidualDebtInsurances.applicant2.push(
            t('BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.HEADER_NOTIFICATIONS.DEATH'),
        );
    if (conditionResidualDebtInsurance?.applicant2?.workIncapacity?.existing)
        applicantResidualDebtInsurances.applicant2.push(
            t('BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.HEADER_NOTIFICATIONS.WORK_INCAPACITY'),
        );
    if (conditionResidualDebtInsurance?.applicant2?.unemployment?.existing)
        applicantResidualDebtInsurances.applicant2.push(
            t('BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.HEADER_NOTIFICATIONS.UNEMPLOYMENT'),
        );

    return `${firstApplicantString} / ${
        applicantResidualDebtInsurances.applicant2.length > 0
            ? applicantResidualDebtInsurances.applicant2.join(', ')
            : '-'
    } (${t('BANK_CREDIT_REQUEST.HISTORY.SECTION_HEADER.SECOND_APPLICANT')})`;
};
